import { useTranslation } from 'react-i18next';
import { ConfirmationModal } from '../UI';

interface ResetPasswordModalProps {
  userName: string;
  // Resetting your own password revokes the token this session is running on, so the confirm
  // button has to say that it signs you out rather than leaving it as a surprise.
  isSelf: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
}

export const ResetPasswordModal = ({
  userName,
  isSelf,
  onConfirm,
  onClose
}: ResetPasswordModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      title={t('config-user-reset-title')}
      message={
        isSelf
          ? t('config-user-reset-self-message')
          : t('config-user-reset-message', { name: userName })
      }
      warning={isSelf ? t('config-user-reset-self-warning') : t('config-user-reset-warning')}
      cancelLabel={t('config-delete-template-cancel')}
      confirmLabel={isSelf ? t('config-user-reset-confirm-self') : t('config-user-reset-confirm')}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};
